/** =======================================================
 * !nordy - Global variables and functions for the Nordy project
 * ========================================================= */

/** =======================================================
 * !nordy - API_URL symlink for custom nodes
 * ========================================================= */
window.COMFY_API_URL = import.meta.env.VITE_COMFYUI_URL ?? ''

window.log = (...args: unknown[]) => {
  console.log(...args)
  const error = new Error()
  Error.captureStackTrace(error, window.log)
  console.warn(error)
}

/** =======================================================
 * !nordy - Fetch interception: redirect relative paths to ComfyUI backend.
 * In Nordy's deployment, the frontend runs on a different origin from ComfyUI,
 * so relative fetch calls (e.g., /api/features, /queue) need to be redirected.
 * This is safe because upstream code using api.apiURL() already produces
 * absolute URLs, and only unqualified relative paths are intercepted.
 * ========================================================= */
const ORIGINAL_FETCH = window.fetch
window.fetch = function (inputUrl, init) {
  if (typeof inputUrl === 'string' && inputUrl.startsWith('/')) {
    const origin = window.COMFY_API_URL
    inputUrl = origin + inputUrl
  }
  return ORIGINAL_FETCH(inputUrl, init)
}

/** =======================================================
 * !nordy - Clear session storage on new window open (not reload)
 * to prevent buggy workflow duplication.
 * Preserves clientId which is set in api.ts.
 * ========================================================= */
function clearSessionStorageForNordy() {
  // readonly 모드(iframe 프리뷰)에서는 이전 세션의 워크플로우 데이터가
  // 잔존하면 의도치 않은 동작을 일으키므로 무조건 정리
  const urlParams = new URLSearchParams(window.location.search)
  const isReadonly = urlParams.get('readonly')

  if (isReadonly) {
    const clientId = sessionStorage.getItem('clientId') ?? ''
    sessionStorage.clear()
    sessionStorage.setItem('clientId', clientId)
    return
  }

  const navigation = performance.getEntriesByType(
    'navigation'
  )[0] as PerformanceNavigationTiming
  const isReload = navigation?.type === 'reload'

  if (window.history.length === 1 && !isReload) {
    const clientId = sessionStorage.getItem('clientId') ?? ''
    sessionStorage.clear()
    sessionStorage.setItem('clientId', clientId)
  }
}

export { clearSessionStorageForNordy }
